// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2Aobh","title":"Images45_title__2F5Sl","images":"Images45_images__2Fhoy"};